export default __webpack_public_path__ + "static/media/paper-plane-3x.8fb6ab26.png";